<template>
    <v-dialog v-model="dialog" persistent>
      <v-card light>
        <v-card-text>{{ message }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="confirm( false )">No</v-btn>
          <v-btn color="green darken-1" flat @click.native="confirm( true )">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ConfirmModal',
    props: {
        dialog: { required: true, default: false },
        message: { required: true }
    },
    methods: {
        confirm( response ) {

          this.$emit('confirm', response)
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/helpers/modals/ConfirmModal.vue